import React from 'react';
import { BrainIcon, ClipboardCheckIcon, FileTextIcon, LibraryIcon, BarChart3Icon, UserCheckIcon } from 'lucide-react';
import { SectionCta } from '../components/SectionCta';
import { audiences, resources } from '../data/content';
const resourceIcons = [ClipboardCheckIcon, BrainIcon, BarChart3Icon, LibraryIcon, FileTextIcon];
export function Audience() {
  return <section className="w-full bg-brand-50 py-14 sm:py-20" aria-labelledby="audience-heading" data-id="element-77" data-mp="uqkm1ea90znj">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-78" data-mp="ps0yxajx5htl">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600" data-id="element-79" data-mp="ptlsawuhyupv">
          Who is this for?
        </p>
        <h2 id="audience-heading" className="mx-auto mt-3 max-w-2xl text-center font-display text-[26px] font-black leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-80" data-mp="yspbs1xktc4w">
          Built for clinicians who plan their own cases
        </h2>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-81" data-mp="2a9p7z8n1ob47">
          {audiences.map(audience => <div key={audience.title} className="flex flex-col rounded-2xl border border-navy-900/10 bg-white p-5" data-id="element-82" data-mp="321nyg61li3m">
              <UserCheckIcon aria-hidden="true" className="h-5 w-5 text-brand-600" data-id="element-83" data-mp="c1orb7ic0xzb" />
              <h3 className="mt-3 font-display text-[16px] font-extrabold uppercase tracking-[0.06em] text-navy-900 sm:text-[17px]" data-id="element-84" data-mp="gzqadsfrcxas">
                {audience.title}
              </h3>
              <p className="mt-2 text-[14px] leading-snug text-ink-700" data-id="element-85" data-mp="3kfnky2hu079n">
                {audience.description}
              </p>
            </div>)}
        </div>

        <div className="mt-12 rounded-2xl bg-white p-5 shadow-card sm:p-8" data-id="element-86" data-mp="3pdgpkr3hkt7t">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-87" data-mp="3u7b8hsb9p45u">
            What makes this different?
          </p>
          <h3 className="mt-3 max-w-2xl font-display text-[22px] font-extrabold leading-tight tracking-tight text-navy-900 sm:text-[28px]" data-id="element-88" data-mp="31pfkjs5inux5">
            It’s built around decisions — not just information.
          </h3>
          <div className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-89" data-mp="2po7iohd0rdcs">
            <div className="rounded-xl border border-navy-900/10 p-4" data-id="element-90" data-mp="33et7emp5mhil">
              <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-ink-500" data-id="element-91" data-mp="33e1a97fwsbq7">
                Instead of
              </p>
              <p className="mt-2 text-[14.5px] italic leading-snug text-ink-700" data-id="element-92" data-mp="2apvochd4cgos">
                “Here’s everything you need to know about aligners.”
              </p>
            </div>
            <div className="rounded-xl border-2 border-brand-500 bg-brand-50 p-4" data-id="element-93" data-mp="26qwk6yz7onye">
              <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-brand-700" data-id="element-94" data-mp="2km8ithghmykl">
                You’ll find
              </p>
              <p className="mt-2 text-[14.5px] font-semibold leading-snug text-navy-900" data-id="element-95" data-mp="3w2yql50k7ygb">
                “Here’s what to evaluate before making this decision.”
              </p>
            </div>
          </div>

          <p className="mt-8 text-[15px] leading-relaxed text-ink-700" data-id="element-96" data-mp="1cwcs0jgqrcs2">
            You don’t need another 8-hour course or weeks of lectures. You need resources you
            can return to while you’re actually planning a case. That’s why the System
            includes:
          </p>

          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-97" data-mp="18u95mzsjans0">
            {resources.map((resource, i) => {
            const Icon = resourceIcons[i % resourceIcons.length];
            return <li key={resource.title} className="rounded-xl bg-brand-50 p-4" data-id="element-98" data-mp="20l5jo3qbyygv" data-mpi={i}>
                  <Icon aria-hidden="true" className="h-5 w-5 text-brand-600" data-id="element-99" data-mp="1mvbrpcjj3y2x" />
                  <p className="mt-2.5 font-display text-[14.5px] font-extrabold uppercase tracking-[0.06em] text-navy-900" data-id="element-100" data-mp="1rtn49v17kmou">
                    {resource.title}
                  </p>
                  <p className="mt-1 text-[13.5px] leading-snug text-ink-700" data-id="element-101" data-mp="2fhmrikzb9uyo">
                    {resource.description}
                  </p>
                </li>;
          })}
          </ul>
        </div>

        <SectionCta label="Yes, this is for me" data-id="element-102" data-mp="qpjtq38qg2xi" />
      </div>
    </section>;
}